/**
 * [validateForm Validate a form]
 * @param {dom element} form [The form object to validate]
 * @return {object} true if valid or an error object if invalid
 */
export function validateForm(form) {
    const requiredInput = [...form.querySelectorAll("input[required], textarea[required], select[required]")];

    let errors = {};

    requiredInput.forEach((element, index) => {
        let value = "";
        let label = "";
        let name = element.getAttribute("name");

        if(element.type !== "radio" && element.type !== "checkbox") {
            value = element.value;
            label = element.dataset.label;
        } else {
            label = element.dataset.label;
            let inputs = document.getElementsByName(name);
            if(inputs.length > 0) {
                for(let index = 0; index < inputs.length; index++) {
                    if(inputs[index].checked) {
                        value = inputs[index].value;
                        index = inputs.length + 1;
                    }
                }
            }
        }

        if(value.length === 0) {
            errors[name] = [`${label} is required`];
        }
    });

    if(Object.keys(errors).length === 0 && errors.constructor === Object) {
        return {
            value: true,
            error: ""
        };
    } else {
        const error = {
            "message": "the_given_data_was_invalid",
            "errors": errors
        };

        return {
            value: false,
            error: error
        };
    }
}